import { render, staticRenderFns } from "./TransferSessionModalAbstract.vue?vue&type=template&id=72f36854&scoped=true&"
import script from "./TransferSessionModalAbstract.vue?vue&type=script&lang=js&"
export * from "./TransferSessionModalAbstract.vue?vue&type=script&lang=js&"
import style0 from "./TransferSessionModalAbstract.vue?vue&type=style&index=0&id=72f36854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f36854",
  null
  
)

export default component.exports